<template>
  <div class="register-container">
    <AppLogo />
    <PageHeader>Создать аккаунт</PageHeader>
    <form @submit.prevent="continueRegistration">
      <InputField
          type="email"
          v-model="emailOrPhone"
          placeholder="Введите почту"
      />
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <button type="submit" class="continue-button">Продолжить</button>

      <InstructionHelp>
        Нажимая «Продолжить», вы подтверждаете, что согласны на обработку персональных данных и ознакомились с
        <router-link to="/privacy-policy" class="privacy-policy-link">политикой конфиденциальности</router-link>
      </InstructionHelp>
    </form>
  </div>
</template>

<script>
import AppLogo from "@/components/auth/AppLogo.vue";
import PageHeader from "@/components/auth/PageHeader.vue";
import InputField from "@/components/auth/InputField.vue";
import InstructionHelp from "@/components/auth/InstructionHelp.vue";
import { sendVerificationCode } from "@/utils/emailVerification";

export default {
  components: { InstructionHelp, InputField, PageHeader, AppLogo },
  data() {
    return {
      emailOrPhone: '',
      errorMessage: '',
    };
  },
  methods: {
    async checkEmail(email) {
      try {
        const response = await fetch(`${process.env.VUE_APP_URL_DEV}/api/email/exists/${email}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error('Ошибка при получении данных с сервера');
        }

        return data.data.exists;
      } catch (error) {
        console.error('Ошибка:', error);
        return false;
      }
    },

    async continueRegistration() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.errorMessage = '';

      if (emailRegex.test(this.emailOrPhone)) {
        try {
          const emailExists = await this.checkEmail(this.emailOrPhone);

          if (emailExists) {
            this.errorMessage = 'Пользователь с этим email уже есть';
            return;
          }

          const sent = await sendVerificationCode(this.emailOrPhone);
          if (!sent) {
            this.errorMessage = 'Произошла ошибка при отправке кода';
            return;
          }

          localStorage.setItem('email', this.emailOrPhone);
          this.$router.push({
            name: 'RegistrationByEmail'
          });
        } catch (error) {
          this.errorMessage = 'Ошибка при проверке email';
          console.error('Ошибка:', error);
        }
      } else {
        this.errorMessage = 'Некорректный формат email';
      }
    },
  },
};
</script>

<style scoped>
.register-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  max-width: 400px;
  margin: auto;
  text-align: center;
}

form {
  display: flex;
  flex-direction: column;
}

.continue-button {
  background-color: #000;
  color: #fff;
  padding: 10px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 15px;
  font-weight: bold;
}

.continue-button:hover {
  background-color: #333;
}

.privacy-policy-link {
  text-decoration: underline;
  color: #000;
  cursor: pointer;
}

.error-message {
  color: red;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
